import {
    Button,    
    Dialog,
    DialogActions,
    DialogTitle,
    makeStyles,
    Divider
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { Box, DialogContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { i18n } from "../../../translate/i18n";
import integrationNames from "./integrationNames.json";
import integrationMethods from "./integrationMethods.json";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useContext } from "react";
import { AuthContext } from "../../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
    root: {
        flexWrap: "wrap",
        maxWidth: '500px'
    },
    btnWrapper: {
        position: "relative",
    },
}));

const ApiInfoModal = ({ open, onClose, integrationId }) => {
    const classes = useStyles();
    const initialState = {
        id: null,
        name: integrationNames['api'][0],
        url: '',
        method: integrationMethods['api'][0],
        body: 'JSON',
        type: 'api',
        auth: { option: 'NOAUTH', user: '', password: '' },
        headers: [
            { key: "Access-Control-Allow-Origin", value: "*" },
            { key: "Access-Control-Allow-Headers", value: "Authorization" },
        ],
        fields: []
    };
    const [integration, setIntegration] = useState(initialState);
    const [company, setCompany] = useState(null);
    const { user } = useContext(AuthContext);

    const isSendMessages = integration?.name === 'SEND_MESSAGES';

    const bodyParams = isSendMessages
        ? [
            { key: "number", value: "Número com DDI e DDD (Obrigatório)." },
            { key: "messageText", value: "Texto, legenda ou título (Opcional se houver url ou localização)." },
            { key: "messageUrl", value: "URL do arquivo (Opcional)." },
            { key: "lat", value: "Latitude — requer log e address (Opcional)." },
            { key: "log", value: "Longitude — requer lat e address (Opcional)." },
            { key: "address", value: "Endereço — requer lat e log (Opcional)." },
            { key: "annotation", value: "true/1 para anotação interna (Opcional)." },
            { key: "queueId", value: "ID da fila de atendimento. Vazio ou inválido → fila Chatbot ou padrão da integração." },
            { key: "ticketStatus", value: "open | closed — status ao criar atendimento novo. Padrão: closed ou configurado na integração." },
        ]
        : [
            { key: "messageText", value: "Texto a ser enviado para a API, ou legenda para arquivos, ou titulo para localizações (Opcional)." },
            { key: "messageUrl", value: "Url do arquivo a ser enviado (Opcional)." },
            { key: "number", value: "Número com o DDI e DDD do número a ser enviado (Obrigatório)." },
            { key: "lat", value: "Latitude da localização, necessário longitude e endereço (Opcional)." },
            { key: "log", value: "Longitude da localização, necessário latitude e endereço (Opcional)." },
            { key: "address", value: "Endereço da localização, necessário longitude e latitude (Opcional)." }
        ];

    const getEndpoint = () => {
        if (!integration?.name) return '';
        const baseUrl = process.env.REACT_APP_BACKEND_URL.endsWith('/') 
            ? process.env.REACT_APP_BACKEND_URL 
            : process.env.REACT_APP_BACKEND_URL + '/';
        const route = integration.name === 'SEND_MESSAGES' ? 'SEND_MESSAGES_V2' : integration.name;
        return `${baseUrl}api/v1/${route}`;
    };

    useEffect(() => {
        if (open == false || !integrationId || isNaN(integrationId)) return;

        let isMounted = true;
        const abortController = new AbortController();

        (async () => {
            try {
                const { data: integrationData } = await api.get(`/integrations/${integrationId}`, { 
                    params: { encryptConnectionId: true}, 
                    signal: abortController.signal,
                });
                if (!isMounted) return;
                setIntegration(integrationData);

                const { data: companyData } = await api.get(`/company/${user.adminId}`, {
                    signal: abortController.signal,
                });
                if (!isMounted) return;
                if(companyData?.company) setCompany(companyData.company);
            } catch (error) {
                if (!isMounted || error.name == 'AbortError') return;
                console.error({ err: error });
                toast.error('Erro ao resgatar conexões, contate o administrador.');
            }
        })();

        return () => {
            isMounted = false;
            abortController.abort();
        };
    }, [open, integrationId, user.adminId]);

    const handleClose = () => {
        setIntegration(initialState);
        setCompany(null);
        onClose();
    };

    const ArrayToJsonView = ({ array }) => {
        const jsonObject = array.reduce((acc, item) => {
            acc[item.key] = item.value || "";
            return acc;
        }, {});

        const formattedJson = JSON.stringify(jsonObject, null, 4);

        return (
            <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                {formattedJson}
            </pre>
        );
    };

    const connectionToken =
        integration?.fields?.find((field) => field.key == "connectionToken")?.value ||
        integration?.fields?.find((field) => field.key == "connectionId")?.value ||
        "";

    return (
        <div className={classes.root}>
            <Dialog 
                open={open == true ? true : false}
                onClose={handleClose} 
                maxWidth="md" 
                fullWidth 
                scroll="paper" 
                disableEscapeKeyDown={true}
            >
                <DialogTitle id="form-dialog-title" style={{ paddingBottom: 0 }}>
                    {i18n.t(`integrations.api.form.info`)}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} mb={2}>
                            <Typography component="label" style={{ fontSize: "1.1rem", fontWeight: "600", marginRight: "10px", color: "#424242" }}>
                                Endpoint:
                            </Typography>
                            {getEndpoint()}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} mb={2}>
                            <Typography component="label" style={{ fontSize: "1.1rem", fontWeight: "600", marginRight: "10px", color: "#424242" }}>
                                Method:
                            </Typography>
                            POST
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} mb={2}>
                            <Typography component="label" style={{ fontSize: "1.1rem", fontWeight: "600", marginRight: "10px", color: "#424242" }}>
                                Header token:
                            </Typography>
                            {company?.token || ''}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} mb={2}>
                            <Typography component="label" style={{ fontSize: "1.1rem", fontWeight: "600", marginRight: "10px", color: "#424242" }}>
                                Header connectionToken:
                            </Typography>
                            {connectionToken}
                        </Grid>
                    </Grid>
                    {isSendMessages && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} mb={2}>
                                <Typography variant="body2" color="textSecondary">
                                    {i18n.t(`integrations.api.form.infoV2Hint`)}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                    <Divider />
                    <Grid container spacing={2}>
                        <Grid item xs={12} mb={2}>
                            <Typography component="label" style={{ fontSize: "1.1rem", fontWeight: "600", marginRight: "10px", color: "#424242" }}>
                                Body Params:
                            </Typography>
                            <ArrayToJsonView array={bodyParams} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary" variant="outlined">
                        {i18n.t(`buttons.close`)}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ApiInfoModal;
